<template>
	<div class="news">
		<div class="section" id="services">
			<div class="container-desktop pad-l">

				<div class="divprova" style="margin-top: -3em; padding:0;">
						<a href="#trial"><button class="provagratuita" id="provagratuita" style="max-width:100%; width:100%;">Prenota subito la PROVA GRATUITA!</button></a>
				</div>
				<!--<div class="divprova">
						<a href="./promo"><img src="@/assets/natale2022banner.jpg" class="bannernatale"></a>
				</div>-->
				<h2 class="section-title">I Nostri Servizi</h2>
				<div class="p-relative">
					<div class="bar">
						<Card class="bg-darker" title="Personal Training" :image="require('@/assets/pt_service.jpg')"><p>È il metodo migliore per raggiungere i tuoi risultati in modo efficiente e sicuro. Gli allenamenti sono personalizzati in base alle tue caratteristiche e dopo una attenta valutazione funzionale, senza lasciare nulla al caso. Ti seguiamo a 360 gradi, con il supporto di altri professionisti (nutrizionista, fisioterapista, osteopata). Possibilità di lezioni singole o di coppia.<br><br><i class="fas fa-dollar-sign"></i> A partire da 37,50€/lezione<br><br><i class="far fa-clock"></i> Giorni e orari in base alle tue disponibilità.</p></Card>
						<Card class="bg-darker" title="Small Class" :image="require('@/assets/sc.jpg')"><p>Allenamenti di gruppo personalizzati di max 6 persone, in modo da garantire sempre massima qualità. Il programma è già definito ma ogni esercizio è adattato al tuo livello per lavorare in sicurezza e in modo efficace. Se ti piace allenarti in gruppo ed essere seguito da un coach esperto le nostre small class fanno per te!<br><br><i class="fas fa-dollar-sign"></i> A partire da 12,50€/lezione o da 130€/mese.<br><br><i class="far fa-clock"></i> ORARI<br>LUN: 7.30-12.30-12.45-18.00-18.30-19.00-19.30-20.00<br>MAR: 7.00-12.30-12.45-18.00-18.30-19.00-19.30<br>MER: 7.30-12.30-12.45-18.00-18.30-19.00-19.30<br>GIOV: 7.00-12.30-12.45-18.00-18.30-19.00-19.30-20.00<br>VEN: 7.30-12.30-12.45-18.00-18.30-19.00-19.30<br>SAB: 10.00-11.00<br>(Gli orari possono essere soggetti a variazioni).</p></Card>
						<Card class="bg-darker" title="Analisi Corsa" :image="require('@/assets/completo.png')"><p>Scopri i nuovi pacchetti per migliorare la tua corsa! Facendo UNA SOLA VOLTA l’analisi biomeccanica della corsa prenderai subito consapevolezza dei tuoi errori e vedrai già la differenza diminuendo il rischio di infortuni, rischio che potrebbe arrivare vicino allo ZERO se oltre all’analisi ti farai seguire anche con programmi personalizzati per migliorare la tua tecnica.<br><br><b>Per maggiori informazioni <a href="./analisicorsa" style="color: #ffe010;">CLICCA QUI</a></b></p></Card>
						<Card class="bg-darker" title="Pacchetti Allenamento e Nutrizionista" :image="require('@/assets/eximusdaitapt.png')"><p><b>Raggiungi finalmente i tuoi risultati!</b><br><br>Abbiamo ideato, insieme al nostro nutrizionista, dei <b>pacchetti di allenamento e nutrizione</b> adatti a tutti, sia per chi si allena da solo con il personal trainer sia per chi frequenta le small class! In questi pacchetti sarà compreso tutto ciò che ti serve per raggiungere il tuo obiettivo. Sono pacchetti con <b>abbonamenti di 3, 6, o 12 mesi</b><br><br><b>Per maggiori informazioni <a href="./eximusdaita" style="color: #ffe010;">clicca qui</a></b></p></Card>
						<Card class="bg-darker" title="Test di movimento e performance" :image="require('@/assets/test_embodimetria.jpeg')" id="test"><p>Abbiamo una grande novità! Vieni a provare i nuovi test per valutare il tuo movimento e la performance, in modo da ottimizzare al meglio il tuo allenamento, migliorare i tuoi punti deboli e migliorare la tua salute e performance.<br><br><b>Per maggiori informazioni <a href="./test" style="color: #ffe010;">CLICCA QUI</a></b></p></Card>
						<Card class="bg-darker" title="Massoterapia" :image="require('@/assets/massoterapia.jpg')"><p>Tipologie di massaggi:<br><ul style="list-style-type: ;"><li>Rilassante</li><li>Decontratturante</li><li>Linfodrenante</li><li>Scarico sportivo</li><li>Terapeutico (cervicale, schiena ecc.)</li><li>Anti-stitichezza</li></ul></p></Card>	
					<!--	<Card class="bg-darker" title="Nutrizionista" :image="require('@/assets/ste-front.jpeg')"><p>Servizi:<br><ul style="text-align: left;"><li>Piano aimentare prsonalizzato</li><li>Valutazion composizione corporea (con bioimpedenziometria AKERN)</li><li>Protocolli di integrazione specifica per la tipologia di attività sportiva</li><li>Consulenza nutrizionale</li></ul><br>Per maggiori informazioni o prenotare la tua visita vai al sito <a href="https://www.daita.it/" target="_blank" style="color: #ffe010;">DAITA.IT</a></p></Card>-->
					</div>
				</div>
				<div class="divprova">
						<a href="#trial"><button class="provagratuita" id="provagratuita">Prenota ora la tua PROVA GRATUITA!</button></a>
				</div>
			</div>
			<div class="container-desktop pad-l">
				<div class="info">
					<ShowMore>
						Da Eximus troverai <b><span style="color:#ffe010;">allenamenti completamente personalizzati</span></b> e studiati in base alle esigenze di ogni persona, <b><span style="color:#ffe010;">nessun vincolo di abbonamento</span></b> e sempre seguiti da <b><span style="color:#ffe010;">personal trainer esperti e qualificati</span></b> che hanno fatto dei loro studi la loro passione e vita.
						Eximus si impone di non essere un semplice “posto dove allenarsi”, ma un punto di riferimento per chiunque voglia migliorarsi fisicamente e mentalmente. Il tutto stando a contatto con uno staff altamente qualificato ed in grado di soddisfare tutte le esigenze e supportare il singolo per raggiungere la migliore versione di sé stesso.
						Puoi allenarti in diverse modalità: <b><span style="color:#ffe010;">personal training singolo o di coppia</span></b>, allenamenti in <b><span style="color:#ffe010;">piccoli gruppi (da 3 a 6 persone)</span></b>, <b><span style="color:#ffe010;">classi a numero chiuso (max 6 persone)</span></b>. In ognuno di questi servizi si sarà sempre affiancati da un coach qualificato sempre a completa disposizione.
					</ShowMore>
					<!-- <div class=servicesphone>
						Eximus propone allenamenti completamente personalizzati e studiati in base alle esigenze di ogni persona, senza alcun vincolo di abbonamento e sempre seguiti da coach esperti e qualificati che hanno fatto dei loro studi la loro passione e vita.
					</div> -->

					<div style="margin-top: 1em;">
						<span>Siamo specializzati in:</span>
						
						<ul style="list-style-type: square;">
							<b><li>Allenamento funzionale</li>
							<li>Riabilitazione pre-post infortunio</li>
							<li>Preparazione atletica</li>
							<li>Ricomposizione corporea</li>
							<li>Valutazione iniziale</li>
							<li>Ginnastica pre e post parto</li></b>
						</ul>
						<span>Collaboriamo con:</span>
						<ul style="list-style-type: square;">
							<b><li>Massoterapista</li>
							<li>Nutrizionista</li>
							<li>Fisioterapista</li>
							<li>Osteopata</li></b>
						</ul>
					</div>
				</div>
			</div>

			<!--<h3 style="font-size:2.3em; text-align: center;">Allenati da casa come in palestra a soli 9,90€/mese!</h3>
			<div class="divprova">
				<a href="/eximus-online-training"><button class="provagratuita" id="provagratuita" @click="">EXIMUS ONLINE TRAINING</button></a>
			</div>-->
		</div>
	</div>
</template>

<script>
import ShowMore from '@/components/global/ShowMore'
import Card from './Card'

export default {
	name: 'news',

	components: {
		ShowMore,
		Card
	},

	data() {

		return {
			showMore: false
		}
	},

	methods: {

	}
}
</script>

<style lang="stylus" scoped>
/* .servicespc
	@media (max-width: unit(media-phone-max, px))
		display none

.servicesphone
	display none 

	@media (max-width: unit(media-phone-max, px))
		display block */

.info
	padding 1em 1.5em

	background repeating-linear-gradient(45deg, rgba(dark, 0), rgba(dark, 0) 1.6em, rgba(dark, 0.5) 1.6em, rgba(dark, 0.5) 3.2em)

	font-family fontSans
	font-size 1.2em

.bar
	display grid
	grid-template-columns repeat(2, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(media-phone-max, px))
		grid-template-columns auto

.bar2
	display grid
	grid-template-columns repeat(2, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(media-phone-max, px))
		grid-template-columns auto


.divprova
	max-width 100%
	padding 2em
	text-align center

.provagratuita
	max-width 600px

	padding 0.6em
	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.6em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.bannernatale
	max-width 70%

	@media (max-width: unit(media-phone-max, px))
		max-width 100%
</style>